import PropTypes from "prop-types";
import CustomText from "../atoms/custom-text.atom";
import FitoWithBubble from "../organism/fito-with-bubble.organism";
import NavBar from "../organism/nav-bar.organism";

const FormScreenTemplate = ({
  title,
  paragraph,
  showButton = false,
  button,
  footerIcon = null,
  fitoComponentProps = {
    display: true,
    message: "",
    emotion: "happy",
  }
}) => {
  return (
    <div style={styles.container}>
      <div style={styles.containerBody}>
        <div style={styles.logoContainer}>
          <div style={styles.logoContent}>
            <NavBar />
          </div>
        </div>

        <div style={styles.contentContainer}>
          <div style={styles.content}>
            <CustomText variant="headline4xl">{title ?? ""}</CustomText>
            <CustomText variant="body">{paragraph ?? ""}</CustomText>
          </div>

          {showButton && (
            <div style={styles.actions}>
              <div style={styles.buttonWrapper}>{button}</div>
            </div>
          )}

          <div style={styles.iconContainer}>
            {
              fitoComponentProps.display && <FitoWithBubble text={fitoComponentProps.message} emotion={fitoComponentProps.emotion} />
            }
          </div>
        </div>
      </div>
      <div style={styles.footerContainer}>
        <div style={styles.footerBackground} />
        {footerIcon && (
          <div style={styles.footerIconContainer}>
            {footerIcon}
          </div>
        )}
      </div>
    </div>
  );
};

const footerBackgroundHeight = "75%";

const footerIconHeight = typeof window !== "undefined" && window.innerWidth >= 768 ? "200px" : "120px";

const styles = {
  containerBody: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    minHeight: "100vh",
    boxSizing: "border-box",
    padding: "24px 16px 16px 16px",
    gap: "16px",
    position: "relative",
    overflow: "hidden",
  },
  container: {

  },
  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    paddingBottom: "8px",
  },
  logoContent: {
    display: "flex",
    flex: 1,
    alignItems: "flex-start",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "16px",
    marginTop: "16px",
    flexGrow: 1,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "flex-start",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: "16px",
    width: "100%",
  },
  buttonWrapper: {
    width: "100%",
    maxWidth: "300px",
  },
  iconContainer: {
    marginTop: "32px",
    alignSelf: "center",
  },

  footerContainer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100vw",
    height: footerIconHeight, // ajusta si el SVG es más alto
    pointerEvents: "none",
    zIndex: 1,
  },

  footerBackground: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: footerBackgroundHeight,
    backgroundColor: "#E0CDFA",
    zIndex: 0, // Valor menor para estar detrás
  },

  footerIconContainer: {
    position: "absolute", // Necesario para posicionar correctamente
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center", // Centra horizontalmente
    alignItems: "flex-end", // Alinea en la parte inferior
    paddingBottom: "20px", // Espacio desde abajo
    zIndex: 3, // Valor mayor para estar encima
    pointerEvents: "auto", // Permitir interacciones con el icono
  },
};

FormScreenTemplate.propTypes = {
  title: PropTypes.node,
  paragraph: PropTypes.node,
  fitoComponentProps: PropTypes.object,
  showButton: PropTypes.bool,
  button: PropTypes.node,
  footerIcon: PropTypes.node,
};

export default FormScreenTemplate;
